<template>
  <div style="margin-top:60px">
    <b-row style="justify-content: center">
      <b-col cols="10">
        <div class="text-left">
          <h5 class="mb-4">
            <b>Your search:</b>
          </h5>
          <p>
            As an added value service and before searching against the
            <a href="#">ethiXbase Sanctions & Enforcements</a> database, we
            provide you with the option of selecting the company record from the
            online registry search results below if available. This would ensure
            that the exact entity names as recorded on company records will be
            screened against
            <a href="#">ethiXbase Sanctions & Enforcements</a> database hits.
          </p>
        </div>
        <b-row class="text-left">
          <b-col cols="8">
            <p>Company name searched: <b>ethiXbase</b></p>
            <p>Country/Territory of Registration selected: ALAND ISLANDS</p>
            <p>
              Please click "Proceed with my original search" to run an Instant
              Due Diligence report (including
              <a href="#">ethiXbase Sanctions & Enforcements</a> ) on the entity
              above without company registry information.
            </p>
          </b-col>
          <b-col style="align-items: center; display: flex" cols="4">
            <b-btn
              @click="onSubmit"
              variant="success"
              style="background: #3ddc97; width: 170px"
            >
              Proceed with orginal search
              <b-icon icon="arrow-right-short"></b-icon>
            </b-btn>
          </b-col>
        </b-row>
        <b-row class="text-left">
          <b-col cols="8">
            <b>Online Registry Matches in ALAND ISLANDS</b>
            <p>
              A search of over 0 records in Aland Islands’s online company
              records has identified the below potential registry matches.
              Please select the most relevant record before clicking "Proceed
              with listed company" to run an Instant Due Diligence (IDD) Report
              (including <a href="#">ethiXbase Sanctions & Enforcements</a> and company registry
              information).
            </p>
          </b-col>
        </b-row>
        <b-row class="text-left">
          <b-col cols="8">
            <b>Potential Online Registry Matches in other locations</b>
            <p>
              Potential company registry details in alternate jurisdictions
              which may be of interest appear below. Should you wish to run an
              Instant Due Diligence report on one of these entities please do
              just select this before clicking "Proceed with alternate
              location". Alternatively please click "Proceed with my original
              search" without making a selection to run an Instant Due Diligence
              (IDD) Report (including <a href="#">ethiXbase Sanctions & Enforcements</a> ) on the
              entity searched without company registry information .
            </p>
          </b-col>
          <b-col cols="4">
            <b-btn
              @click="onSubmit"
              variant="success"
              style="background: #3ddc97; width: 170px"
            >
              Proceed with alternate location (select)
              <b-icon icon="arrow-right-short"></b-icon>
            </b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-table
              head-variant="light"
              :items="items"
              :fields="staticFields"
            >
              <template v-slot:cell(select)>
                <b-form-checkbox class="text-center"></b-form-checkbox>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ReviewComppanyResult",
  data() {
    return {
      staticFields: [
        { key: "company_name", label: "Registered Company Name" },
        { key: "registered_country", label: "Registered Country" },
        { key: "registration_status", label: "Registration Status" },
        { key: "select", label: "Select" },
      ],
      items: [
        {
          company_name: "EthixBase",
          registered_country: "Pakistan",
          registration_status: "ACTIF",
        },
        {
          company_name: "EthixBase",
          registered_country: "Pakistan",
          registration_status: "ACTIF",
        },
        {
          company_name: "EthixBase",
          registered_country: "Pakistan",
          registration_status: "ACTIF",
        },
      ],
    };
  },
  methods:{
    onSubmit(){
        this.$store.state.tabIndex++
        this.$store.state.associateTab = false;
    }
  }
};
</script>

<style>
</style>